import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import ProjectTeamManager from './ProjectTeamManager';

const ProjectTeamAssignment = () => {
  const { projects, users, assignEmployeeToProject, removeEmployeeFromProject } = useData();
  const { currentUser } = useAuth();
  const [selectedProject, setSelectedProject] = useState(null);
  const [showTeamManager, setShowTeamManager] = useState(false);
  const [loading, setLoading] = useState(false);

  // Only owners can access this
  if (currentUser?.role !== 'owner') {
    return (
      <div className="access-denied">
        <h3 className="text-primary">Access Restricted</h3>
        <p className="text-secondary">Only owners can manage project teams.</p>
      </div>
    );
  }

  const activeProjects = projects.filter(p => p.status !== 'completed');
  const employees = users.filter(u => u.role === 'employee' || u.role === 'project_manager');

  const openTeamManager = (project) => {
    setSelectedProject(project);
    setShowTeamManager(true);
  };

  const getTeamMemberNames = (project) => {
    if (!project.teamMembers || project.teamMembers.length === 0) {
      return 'No team members';
    }
    
    const memberNames = project.teamMembers
      .map(memberId => {
        const user = users.find(u => u.id === memberId);
        return user?.name || 'Unknown';
      })
      .slice(0, 3); // Show first 3 names
    
    const remaining = project.teamMembers.length - 3;
    if (remaining > 0) {
      memberNames.push(`+${remaining} more`);
    }
    
    return memberNames.join(', ');
  };

  return (
    <div className="project-team-assignment">
      <div className="page-header">
        <div className="header-contentr">
          <h2>Project Team Management</h2>
          <p>Assign employees to projects and manage team compositions</p>
        </div>
      </div>

      <div className="team-assignment-grid">
        {activeProjects.length > 0 ? (
          activeProjects.map(project => (
            <div key={project.id} className="project-team-card">
              <div className="project-header">
                <div className="project-info">
                  <h3 className="text-primary">{project.name}</h3>
                  <p className="text-secondary">{project.description}</p>
                </div>
                <div className="project-badges">
                  <span className={`status-badge status-${project.status}`}>
                    {project.status?.replace('_', ' ')}
                  </span>
                  <span className={`priority-badge priority-${project.priority}`}>
                    {project.priority}
                  </span>
                </div>
              </div>

              <div className="project-manager">
                <div className="manager-info">
                  <i className="fas fa-user-tie"></i>
                  <span className="text-secondary">Manager: </span>
                  <strong className="text-primary">{project.managerName}</strong>
                </div>
              </div>

              <div className="team-info">
                <div className="team-count">
                  <i className="fas fa-users"></i>
                  <span className="text-secondary">
                    Team Size: <strong className="text-primary">{project.teamMembers?.length || 0}</strong>
                  </span>
                </div>
                <div className="team-members">
                  <span className="text-muted">{getTeamMemberNames(project)}</span>
                </div>
              </div>

              <div className="project-actions">
                <button
                  className="btn btn-primary"
                  onClick={() => openTeamManager(project)}
                >
                  <i className="fas fa-users-cog"></i>
                  Manage Team
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <i className="fas fa-project-diagram"></i>
            <h3 className="text-primary">No Active Projects</h3>
            <p className="text-secondary">Create some projects first to assign teams.</p>
          </div>
        )}
      </div>

      {/* Team Manager Modal */}
      {showTeamManager && selectedProject && (
        <ProjectTeamManager
          project={selectedProject}
          onClose={() => {
            setShowTeamManager(false);
            setSelectedProject(null);
          }}
        />
      )}
    </div>
  );
};

export default ProjectTeamAssignment;

